import { Ref } from 'vue';
import { ImageItem } from '@/common/services/swagger/index.defs';
import { IInstance } from '@/common/api/runtime/IInstance';
import { Instance as CatalogsInstance } from '@/catalogs/api/Instance';
import { Instance as ProductsInstance } from '@/products/api/Instance';
export type ImageItemRecords = Record<string, ImageItem[]>;

export type ImageStorage = {
  getProductsImages: (productIds: string[]) => Promise<ImageItemRecords>;
};

export type ImageStorageSetup = (instance: Ref<IInstance | undefined>) => () => ImageStorage;

// It's global to allow every instance to store images info in one place
const productsImages = <ImageItemRecords>{};

export const setupImageStorage: ImageStorageSetup = (instance) => () => {
  const getProductsImages = async (productIds: string[]) => {
    const idsToFetch = productIds.filter((id) => !productsImages[id]);

    if (idsToFetch.length) {
      const response =
        instance.value?.instanceType == 'Products'
          ? await (instance.value as ProductsInstance)?.httpService?.loadImages(idsToFetch)
          : await (instance.value as CatalogsInstance)?.httpService?.loadImages(idsToFetch);

      response?.items?.forEach((item) => {
        const id = item.productId;
        if (id) {
          if (!productsImages[id]) {
            productsImages[id] = [];
          }
          productsImages[id].push(item);
        }
      });
    }

    return productIds.reduce((acc, id) => {
      acc[id] = productsImages[id];
      return acc;
    }, {});
  };

  return {
    getProductsImages,
  };
};
